import { api } from '../../../../components/common';
import {
  ExpensesByPropertyReport,
  ReportCatalogResponse,
  ReportPropertyOption
} from '../types';

export const reportsApi = {
  getCatalog: (): Promise<ReportCatalogResponse> =>
    api.get('/reports/catalog').then((res) => res.data),

  getExpenseProperties: (): Promise<{ properties: ReportPropertyOption[] }> =>
    api.get('/reports/expense/properties').then((res) => res.data),

  getExpenseYears: (propertyId: number): Promise<{ years: number[] }> =>
    api.get('/reports/expense/years', { params: { propertyId } }).then((res) => res.data),

  getExpensesByProperty: (propertyId: number, year: number): Promise<ExpensesByPropertyReport> =>
    api.get('/reports/expense/by-property', { params: { propertyId, year } }).then((res) => res.data),

  downloadExpensesByPropertyHtml: (propertyId: number, year: number): Promise<Blob> =>
    api
      .get('/reports/expense/by-property/html', {
        params: { propertyId, year },
        responseType: 'blob'
      })
      .then((res) => res.data)
};
